import _isArray from 'lodash/isArray';
import { getOpeningHoursSpecification } from './openingHours';

function locationToPostalAddress(location) {
  let hours = null;
  const openedHours = location.hours.filter(
    ({open, close}) => !!open && !!close
  );
  const isOpenSomeDay = openedHours.length > 0
  if (isOpenSomeDay) {
    hours = getOpeningHoursSpecification(openedHours);
  }
  return {
    "@type": "PostalAddress",
    addressLocality: location.city,
    addressRegion: location.state,
    streetAddress: location.street,
    email: location.email,
    telephone: location.phoneNumber,
    name: location.name,
    hoursAvailable: hours,
  };
}

export default (address, onlyPrimary = false) => {
  if (!address) {
    return null;
  }

  if (typeof address === 'string') {
    return address;
  }

  if (_isArray(address)) {
    if (onlyPrimary) {
      return locationToPostalAddress(address[0]);
    }
    return address.map(locationToPostalAddress);
  }

  return locationToPostalAddress(address);
};
